import { buildChartAxisTimestamps } from 'components/shared/processes/chartNoDataSeries'
import { ILamenessGraphResponse } from 'models/ICattlesData'

export const LAMENESS_CHART_MOCK_QUERY = 'lamenessChartMock'
export const LAMENESS_CHART_MOCK_STORAGE_KEY = 'sf_mock_lameness_chart'
const COWVISION_API = 'https://api.cowvision.ru/'

export const LAMENESS_CHART_MOCK_MODES = [
	'gap',
	'empty',
	'zero',
	'leading',
	'trailing',
] as const

export type LamenessChartMockMode = (typeof LAMENESS_CHART_MOCK_MODES)[number]

const MOCK_LINES = [
	{ score: 1, label: '1 балл', value: 4000 },
	{ score: 2, label: '2 балла', value: 80 },
	{ score: 3, label: '3 балла', value: 40 },
	{ score: 4, label: '4 балла', value: 12 },
	{ score: 5, label: '5 баллов', value: 4 },
]

const isMockMode = (value: string | null): value is LamenessChartMockMode =>
	LAMENESS_CHART_MOCK_MODES.includes(value as LamenessChartMockMode)

const isCowvisionApi = () => process.env.REACT_APP_SERVER_NAME === COWVISION_API

export const getLamenessChartMockMode = (): LamenessChartMockMode | null => {
	if (typeof window === 'undefined') return null
	if (!isCowvisionApi()) return null

	const fromQuery = new URLSearchParams(window.location.search).get(
		LAMENESS_CHART_MOCK_QUERY,
	)
	const fromStorage = window.localStorage.getItem(
		LAMENESS_CHART_MOCK_STORAGE_KEY,
	)

	if (isMockMode(fromQuery)) return fromQuery
	if (isMockMode(fromStorage)) return fromStorage
	return null
}

const holeIndexForMode = (
	mode: LamenessChartMockMode,
	length: number,
): number => {
	if (length <= 0) return -1
	if (mode === 'gap') return Math.floor(length / 2)
	if (mode === 'leading') return 0
	if (mode === 'trailing') return length - 1
	return -1
}

export const buildLamenessChartMock = (
	startDate: number,
	endDate: number,
	monthly: boolean,
	mode: LamenessChartMockMode,
): ILamenessGraphResponse => {
	const timestamps = buildChartAxisTimestamps(startDate, endDate, monthly)
	const holeIndex = holeIndexForMode(mode, timestamps.length)

	const lines = MOCK_LINES.map(line => {
		if (mode === 'empty') {
			return { score: line.score, label: line.label, dots: [] }
		}

		return {
			score: line.score,
			label: line.label,
			dots: timestamps.flatMap((date_ms, index) => {
				if (index === holeIndex) return []
				return [
					{
						date_ms,
						value: mode === 'zero' && line.score !== 1 ? 0 : line.value,
					},
				]
			}),
		}
	})

	const healthy = mode === 'empty' ? 0 : 4000
	const limp = mode === 'empty' || mode === 'zero' ? 0 : 136

	return {
		lines,
		healthy_count: healthy,
		limp_count: limp,
	}
}
